import React, { FC } from 'react'
import { XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, Area, AreaChart, CartesianGrid } from 'recharts'

import { Box } from '@mui/material'
import Title from '../Title'

interface ChartTestsProps {
  results: any
  testTypes: any
  title: string
}

const ChartTests: FC<ChartTestsProps> = ({ results, testTypes, title }) => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      {title && <Title> {title}</Title>}
      <ResponsiveContainer width="100%" height={340}>
        <AreaChart data={results} margin={{ top: 5, right: 30, left: -10, bottom: 5 }}>
          <XAxis dataKey="time" fontSize={12} tickMargin={15} />
          <YAxis fontSize={12} tickMargin={10} />
          <Tooltip />
          {Object.values(testTypes).map((type) => (
            <Area
              key={type.value}
              type="monotone"
              dataKey={type.value}
              stroke={type.color}
              fill={type.color}
              strokeDasharray="3 3"
            />
          ))}
          <CartesianGrid strokeDasharray="3 3" />
          <Legend verticalAlign="bottom" height={-20} />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  )
}
export default ChartTests
